import { type InsuranceCorporateIdentity } from "../types";

export function BergischeKrankenkasseLogo({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_30_170)">
        <path
          d="M80 198.239H147.661C176.616 198.239 200.904 218.781 200.904 250.052C200.904 283.189 178.95 296.268 154.212 296.268H80V198.239Z"
          fill="#006238"
        />
        <path
          d="M223.049 198.239L277.865 296.268H339.389L269.032 171.442L312.888 99H283.345L223.049 198.239Z"
          fill="#52AE32"
        />
        <path
          d="M317.642 198.239L372.476 296.268H434L363.643 171.442L407.499 99H377.956L317.642 198.239Z"
          fill="#52AE32"
        />
        <path
          d="M80 99H116.614C140.781 99 155.872 112.58 155.872 136.353C155.872 160.126 141.524 171.442 120.382 171.442H80V99Z"
          fill="#006238"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M84.3563 425.343V408.671L98.8599 425.343H104.997L89.3695 407.98L103.424 393.917H97.4597L84.3563 407.548V393.917H80V425.343H84.3563Z"
          fill="#1D1D1B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M113.052 397.666H120.244C125.084 397.89 126.173 400.067 126.173 402.538C126.173 405.009 125.084 407.185 120.244 407.41H113.052V397.666ZM119.241 411.159C120.987 411.297 122.733 411.159 123.995 412.593C125.43 414.165 125.43 416.722 125.776 419.556C126 421.422 126.519 423.478 126.899 425.343H131.549C130.426 422.389 130.063 419.037 129.596 415.893C129.112 412.369 128.593 410.364 124.807 409.449V409.362C128.472 408.498 130.737 405.579 130.737 401.795C130.737 395.575 125.292 393.917 120.019 393.917H108.783V425.343H113.139V411.159H119.241Z"
          fill="#1D1D1B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M139.519 425.343L142.907 417.154H157.497L160.885 425.343H165.639L152.916 393.917H148.266L135.024 425.343H139.501H139.519ZM150.409 398.236L156.114 413.422H144.394L150.409 398.236Z"
          fill="#1D1D1B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M191.759 393.917V419.901H191.673L176.34 393.917H170.376V425.343H174.248V398.668H174.334L190.238 425.343H195.632V393.917H191.759Z"
          fill="#1D1D1B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M209.115 425.343V408.671L223.619 425.343H229.756L214.129 407.98L228.183 393.917H222.219L209.115 407.548V393.917H204.759V425.343H209.115Z"
          fill="#1D1D1B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M253.923 425.343V421.594H238.192V411.194H252.834V407.462H238.192V397.666H253.923V393.917H233.836V425.343H253.923Z"
          fill="#1D1D1B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M282.861 393.917V419.901H282.775L267.441 393.917H261.477V425.343H265.35V398.668H265.436L281.34 425.343H286.733V393.917H282.861Z"
          fill="#1D1D1B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M300.217 425.343V408.671L314.721 425.343H320.858L305.23 407.98L319.285 393.917H313.321L300.217 407.548V393.917H295.861V425.343H300.217Z"
          fill="#1D1D1B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M326.217 425.343L329.605 417.154H344.195L347.6 425.343H352.354L339.631 393.917H334.981L321.739 425.343H326.217ZM337.107 398.236L342.812 413.422H331.091L337.107 398.236Z"
          fill="#1D1D1B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M355.016 416.152C354.844 423.201 359.632 425.983 366.201 425.983C372.77 425.983 378.959 423.46 378.959 416.325C378.959 408.412 371.076 408.412 365.285 406.529C362.536 405.665 360.012 405.44 360.012 401.864C360.012 398.288 364.23 396.992 367.325 396.992C370.419 396.992 373.427 398.219 373.6 401.743H378.164C378.164 395.644 372.891 393.26 367.532 393.26C361.655 393.26 355.431 395.783 355.431 402.624C355.431 409.466 364.057 410.848 369.226 411.988C371.837 412.507 374.36 413.768 374.36 416.826C374.36 421.214 370.004 422.268 366.443 422.268C362.225 422.268 359.649 420.61 359.563 416.169H354.999L355.016 416.152Z"
          fill="#1D1D1B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M384.058 416.152C383.885 423.201 388.674 425.983 395.243 425.983C401.812 425.983 408.001 423.46 408.001 416.325C408.001 408.412 400.118 408.412 394.327 406.529C391.578 405.665 389.054 405.44 389.054 401.864C389.054 398.288 393.272 396.992 396.366 396.992C399.461 396.992 402.469 398.219 402.642 401.743H407.223C407.223 395.644 401.95 393.26 396.591 393.26C390.714 393.26 384.49 395.783 384.49 402.624C384.49 409.466 393.117 410.848 398.303 411.988C400.913 412.507 403.437 413.768 403.437 416.826C403.437 421.214 399.081 422.268 395.519 422.268C391.301 422.268 388.726 420.61 388.639 416.169H384.076L384.058 416.152Z"
          fill="#1D1D1B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M434 425.343V421.594H418.286V411.194H432.911V407.462H418.286V397.666H434V393.917H413.93V425.343H434Z"
          fill="#1D1D1B"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M89.9054 371.992V359.726H97.6326C102.3 359.726 105.498 360.555 105.498 365.859C105.498 371.163 102.3 371.992 97.6326 371.992H89.9054ZM89.9054 352.072V341.222H97.6326C101.781 341.222 104.081 342.95 104.081 346.647C104.081 350.344 101.781 352.072 97.6326 352.072H89.9054ZM97.4424 379.663C104.53 380.182 116.043 376.847 116.043 367.725C116.043 360.952 111.704 356.927 105.878 355.718V355.597C110.477 354.059 113.986 350.552 113.986 345.507C113.986 336.506 105.55 333.05 97.3041 333.569H80V379.681H97.4424V379.663Z"
          fill="#006238"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M121.972 379.646H153.607V371.992H131.878V359.657H151.567V352.003H131.878V341.205H153.607V333.534H121.972V379.646Z"
          fill="#006238"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M171.033 341.205H179.348C183.687 341.274 186.245 342.984 186.245 347.045C186.245 351.105 183.687 353.264 179.348 353.333H171.033V341.205ZM171.033 361.004H181.508C184.758 361.125 185.415 364.65 185.657 367.224C186.107 371.388 186.556 375.551 187.386 379.663H198.311C196.462 377.106 196.081 371.647 195.632 368.71C194.802 362.3 194.802 357.635 187.196 356.806V356.685C192.883 355.476 196.79 351.519 196.79 345.541C196.79 336.177 188.665 333.62 180.748 333.551H161.127V379.663H171.033V361.022V361.004Z"
          fill="#006238"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M235.046 362.732V372.442C232.418 372.96 229.808 373.461 225.849 373.461C217.085 373.461 212.884 367.017 212.884 356.599C212.884 346.181 217.102 339.736 225.849 339.736C231.277 339.736 235.115 341.723 235.115 347.597H245.66C245.591 336.609 237.362 332.584 223.999 332.584C214.872 332.584 202.339 338.268 202.339 356.599C202.339 374.929 214.872 380.614 223.999 380.614C230.067 380.614 232.366 380.354 234.614 380.164C238.192 379.853 241.58 379.214 244.968 378.126V355.078H226.057V362.732H235.063H235.046Z"
          fill="#006238"
        />
        <path
          d="M263.448 333.534H253.543V379.646H263.448V333.534Z"
          fill="#006238"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M305.853 346.699C305.853 337.439 298.886 332.584 289.949 332.584C280.493 332.584 270.778 337.249 270.778 347.787C270.778 355.959 279.594 358.896 286.059 360.486C290.018 361.505 296.604 361.885 296.604 367.328C296.604 372.252 291.366 373.461 287.408 373.461C282.239 373.461 279.3 370.006 279.68 364.909H269.585C269.274 376.536 276.742 380.614 287.287 380.614C297.192 380.614 307.166 376.657 307.166 365.22C307.166 355.959 296.812 353.99 289.776 352.193C285.817 351.226 281.34 350.655 281.34 345.68C281.34 341.654 285.039 339.736 288.687 339.736C293.475 339.736 295.965 342.034 296.362 346.699H305.887H305.853Z"
          fill="#006238"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M350.833 348.478C350.384 336.92 342.069 332.584 331.472 332.584C318.109 332.584 312.11 343.123 312.11 356.599C312.11 370.075 318.109 380.614 331.472 380.614C342.086 380.614 350.384 376.277 350.833 364.719H340.288C340.357 369.574 337.418 373.461 331.472 373.461C324.453 373.461 322.655 363.06 322.655 356.599C322.655 350.137 324.453 339.736 331.472 339.736C337.418 339.736 340.357 343.641 340.288 348.478H350.833Z"
          fill="#006238"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M366.875 379.646V359.397H384.439V379.646H394.344V333.534H384.318V351.744H366.875V333.534H356.97V379.646H366.875Z"
          fill="#006238"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M402.382 379.646H434V371.992H412.27V359.657H431.96V352.003H412.27V341.205H434V333.534H402.382V379.646Z"
          fill="#006238"
        />
      </g>
      <defs>
        <clipPath id="clip0_30_170">
          <rect
            width="354"
            height="327"
            fill="white"
            transform="translate(80 99)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export const BergischeKrankenkasse: InsuranceCorporateIdentity = {
  id: "bergische-krankenkasse",
  name: "Bergische Krankenkasse",
  logo: BergischeKrankenkasseLogo,
  backgroundColor: "#FFFFFF",
  textColor: "#006238",
  wildcard: "bergische krankenkasse",
  type: "statutory",
};
